import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/all/";

const getCpaiRpl = 'sertifikasi-rpl';
const getDetailRplCPAI = 'sertifikasi-rpl';
const postRplCpaiUrl = 'sertifikasi-rpl';
const putRplCpaiUrl = 'sertifikasi-rpl/';
const deleteCpaiRpl = 'sertifikasi-rpl/delete-sertifikasi-rpl/';

class CpaiRplService {
    getCpaiRpl(currentPage, pageSize, filter) {
        return axios.get(
            API_URL + getCpaiRpl + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter + '&kategoriRpl=CPAI',
            {
                headers: authHeader()
            });
    }
    getDetailRplCPAI(idSertifikasiRpl) {
        return axios.get(
            API_URL + getDetailRplCPAI + idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    postRplCpai(formData) {
        // 39b99d4b-0cdd-40e1-8a1e-61905c6b5329
    
        return axios
            .post(
                API_URL + postRplCpaiUrl,
                formData,
                {
                    headers: authHeader()
                }
            );
    }

    putRplCPAI(formData) {
        return axios
            .put(
                API_URL + putRplCpaiUrl + formData.idSertifikasiRpl, 
                formData,
                {
                    headers: authHeader()
                }
            );
    }

    deleteCpaiRpl(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteCpaiRpl + formData.id_sertifikasi_rpl,
                { headers: authHeader() }
            );
    }

}

export default new CpaiRplService();
